import { service } from '@/utils/request'

export default {
  // 职称
  jobTitlePages(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/jobTitlePages',
      method: 'get',
      params: params
    })
  },
  saveJobTitle(data) {
    return service({
      url: '/cloud/uac/admin/adLabour/saveJobTitle',
      method: 'post',
      data
    })
  },
  deleteJobTitle(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/deleteJobTitle',
      method: 'post',
      params: params
    })
  },
  // 协会
  associationPages(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/associationPages',
      method: 'get',
      params
    })
  },
  saveAssociation(data) {
    return service({
      url: '/cloud/uac/admin/adLabour/saveAssociation',
      method: 'post',
      data
    })
  },
  deleteAssociation(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/deleteAssociation',
      method: 'post',
      params
    })
  },
  // 公司
  companyPages(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/companyPages',
      method: 'get',
      params
    })
  },
  saveCompany(data) {
    return service({
      url: '/cloud/uac/admin/adLabour/saveCompany',
      method: 'post',
      data
    })
  },
  deleteCompany(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/deleteCompany',
      method: 'post',
      params
    })
  },

  // 项目
  projectPages(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/projectPages',
      method: 'get',
      params
    })
  },
  saveProjectList(data) {
    return service({
      url: '/cloud/uac/admin/adLabour/saveProjectList',
      method: 'post',
      data
    })
  },
  updateProject(data) {
    return service({
      url: '/cloud/uac/admin/adLabour/updateProject',
      method: 'post',
      data
    })
  },
  deleteProject(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/deleteProject',
      method: 'post',
      params
    })
  },

  // 销售
  salesPages(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/salesPages',
      method: 'get',
      params
    })
  },
  updatePages(data) {
    return service({
      url: '/cloud/uac/admin/adLabour/updatePages',
      method: 'post',
      data
    })
  },

  // 项目收集列表
  collectPages(path) {
    return service({
      url: '/cloud/uac/admin/adLabour/collection/' + path,
      method: 'get'
    })
  },

  // 讲师
  doctorPages(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/doctorPages',
      method: 'get',
      params
    })
  },
  doctorDetail(path) {
    return service({
      url: '/cloud/uac/admin/adLabour/doctorDetail/' + path,
      method: 'get'
    })
  },
  // 导出
  exportFile(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/downFile',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },
  searchProjectList(params) {
    return service({
      url: '/cloud/uac/admin/adLabour/searchProjectList',
      method: 'post',
      params
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/thirdManage/labour.js